import React, { useEffect, useState } from "react";
import request from "../../../utils/requests";
import styles from "./styles.module.scss";
import LogoUrl from "../../../public/static-next/logo-url.svg";
import Image from "next/image";
import parse from "html-react-parser";
import securityToken from "../../../utils/securityToken";

interface FormInputTypes extends HTMLFormControlsCollection {
  name: HTMLInputElement;
  email: HTMLInputElement;
}

interface FormTypes extends HTMLFormElement {
  readonly elements: FormInputTypes;
}

interface FormDataTypes {
  slug: string;
  ebookCover: {
    title: string;
    alt: string;
    src: string;
  };
  formText: string;
}

interface SubscriptionResponseTypes {
  formSent: boolean;
  success: boolean;
}

export const FormEbook = ({ postId }): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [formSubmitted, setFormSubmitted] = useState<SubscriptionResponseTypes>(
    {
      formSent: false,
      success: false,
    }
  );
  const [formData, setFormData] = useState<FormDataTypes>();

  const getBlockData = async () => {
    const data: FormDataTypes = await request.get(
      `/api/block/ebook-subscription/?postId=${postId}`
    );

    setFormData(data);
    setIsLoading(false);
  };

  useEffect(() => {
    getBlockData();
  }, []);

  const formHandle = async (e: React.FormEvent<FormTypes>) => {
    e.preventDefault();

    const cryptoKey = securityToken.encode({
      exp: securityToken.defaultExp(),
    });

    const { name, email } = e.currentTarget.elements;

    const formParams = {
      name: name.value,
      email: email.value,
      cryptoKey: cryptoKey,
      slug: formData.slug,
    };

    const formParamsQueryString = new URLSearchParams(formParams);

    try {
      await request.post(`/api/ebook/subscribe/?${formParamsQueryString}`);

      setFormSubmitted({
        formSent: true,
        success: true,
      });
    } catch (error) {
      setFormSubmitted({
        formSent: true,
        success: false,
      });
    }
  };

  return (
    <div className={styles.ebookForm}>
      {!formSubmitted.formSent ||
      (formSubmitted.formSent && !formSubmitted.success) ? (
        <>
          <div className={styles.contentWrapper}>
            <div className={styles.imageWrapper}>
              <Image
                src="/static-next/imagem_blog.png"
                fill
                alt=""
                loading="lazy"
              />
            </div>
            <div data-loading={isLoading}>
              {formData && parse(formData.formText)}
            </div>
          </div>
          <form className={styles.formWrapper} onSubmit={formHandle}>
            <input
              required
              placeholder="Nome"
              name="name"
              type={"text"}
            ></input>
            <input
              required
              placeholder="E-mail"
              name="email"
              type={"email"}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            ></input>
            <button disabled={isLoading}>Enviar</button>
            {formSubmitted.formSent && !formSubmitted.success && (
              <span className={styles.errorMessage}>
                Ocorreu um erro. Tente novamente.
              </span>
            )}
          </form>
        </>
      ) : (
        <>
          <div className={styles.successWrapper}>
            <div className={styles.imageWrapper}>
              <Image
                src={formData.ebookCover.src}
                fill
                alt={formData.ebookCover.alt}
                title={formData.ebookCover.title}
                loading="lazy"
              />
            </div>
            <div className={styles.content} data-loading={isLoading}>
              <h3 className={styles.title}>Obrigado por se cadastrar!!</h3>
              <p>
                Em breve você receberá um e-mail, com a confirmação do seu
                cadastro e um link para realizar o download do nosso{" "}
                <strong>E-BOOK</strong> com todas as informações sobre{" "}
                <strong>Empréstimo para Negativados.</strong>
              </p>
            </div>
          </div>
        </>
      )}
      <div className={styles.bottomWrapper}>
        <LogoUrl />
      </div>
    </div>
  );
};
